import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {AppConfigService} from '../../../../services/app-config.service';

@Component({
  selector: 'app-area-icon',
  templateUrl: './area-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AreaIconComponent {
  public area = input<string>(null);

  appConfigService = inject(AppConfigService);

  private illustrations = [
    {area: 'populära', path: 'like.svg'},
    {area: 'akut- & intensivvård', path: 'blood_drop.svg'},
    {area: 'allmänvård', path: 'stetoscope.svg'},
    {area: 'assistans & vård i hemmet', path: 'bed.svg'},
    {area: 'barn- och ungdom', path: 'child.svg'},
    {area: 'beroende', path: 'pill_jar.svg'},
    {area: 'cancer', path: 'cancer.svg'},
    {area: 'graviditet & sexuell hälsa', path: 'pregnancy.svg'},
    {area: 'hjärta & kärl', path: 'heart.svg'},
    {area: 'hormoner', path: 'hormones.svg'},
    {area: 'hud & skönhet', path: 'face.svg'},
    {area: 'infektion & klinisk kemi', path: 'bacteria.svg'},
    {area: 'kirurgi', path: 'surgery.svg'},
    {area: 'lungor & allergi', path: 'lungs.svg'},
    {area: 'mage & matsmältning', path: 'intestines.svg'},
    {area: 'muskler & leder', path: 'muscle.svg'},
    {area: 'neurologi', path: 'neuron.svg'},
    {area: 'njurar', path: 'kidneys.svg'},
    {area: 'psykisk hälsa', path: 'brain.svg'},
    {area: 'röntgen', path: 'radiology.svg'},
    {area: 'tandvård', path: 'tooth.svg'},
    {area: 'vård i livets slutskede', path: 'holding_hands.svg'},
    {area: 'äldrevård', path: 'stick.svg'},
    {area: 'ögon', path: 'eye.svg'},
    {area: 'öron näsa hals', path: 'ear.svg'},
    {area: 'övrigt', path: 'ambulance.svg'},
  ];

  public path = computed<string>(() => {
    const path: string = this.illustrations.find((i) => i.area === this.area()?.toLowerCase())?.path;
    return path ? `${this.appConfigService.appConfig.amazonS3Url}assets/illustrations/${path}` : null;
  });
}
